export const MENU_GROUPS = [
    {
        name: 'admin',
        allowed: ['admin', 'super_admin'],
        menus: [
            // {
            //     to: '/user-folder-authorizev2',
            //     label: 'Folder Authorize Mapping'
            // },
            // {
            //     to: '/user-folder-authorizev2/log',
            //     label: 'Folder Authorize Log'
            // }
        ]
    },
    {
        group: 'super-admin',
        allowed: ['admin', 'super_admin'],
        menus: [
            // {
            //     to: '/dms/meta-data-group',
            //     label: 'Metadata Group'
            // },
            // {
            //     to: '/dms/meta-data',
            //     label: 'Metadata'
            // },
            // {
            //     to: '/dms/role-access',
            //     label: 'Authorization'
            // },
            // {
            //     to: '/folder-authorize',
            //     label: 'Folder Authorize'
            // },
            // {
            //     to: '/callback',
            //     label: 'Callback'
            // },
            // {
            //     to: '/access-management',
            //     label: 'Access Management'
            // },
            {
                to: '/employee',
                label: 'ADM-DMS100 Master Employee'
            },
            {
                to: '/admin-management',
                label: 'ADM-DMS101 Admin Management'
            },
            {
                to: '/dms/folder-group',
                label: 'ADM-DMS102 Folder Group Management'
            },
            {
                to: '/dms/folder-group-user',
                label: 'ADM-DMS103 Folder Group Mapping User'
            },
            {
                to: '/dms/configure-default-values',
                label: 'ADM-DMS104 Default Values Management'
            },
            {
                to: '/dms/annual-folder',
                label: 'ADM-DMS105 Annual Folder Management'
            },
            {
                to: '/dms/auth-history',
                label: 'ADM-DMS106 Authentication History'
            },
            // {
            //     to: '/dms/log',
            //     label: 'ADM-DMS107 DMS Log'
            // }
        ]
    }
];
